export type LoginTab = 'signin' | 'signup';

interface LoginTabsProps {
  activeTab: LoginTab;
  onSelectTab: (tab: LoginTab) => void;
}

const tabClasses = (isActive: boolean) =>
  `flex-1 py-3 text-center font-medium transition-colors ${
    isActive
      ? 'text-primary-600 border-b-2 border-primary-600'
      : 'text-gray-500 hover:text-gray-700'
  }`;

/** Sign In / Create Account tab strip at the top of the login card. */
export const LoginTabs = ({ activeTab, onSelectTab }: LoginTabsProps) => (
  <div className="flex border-b border-gray-200 mb-6">
    <button onClick={() => onSelectTab('signin')} className={tabClasses(activeTab === 'signin')}>
      Sign In
    </button>
    <button onClick={() => onSelectTab('signup')} className={tabClasses(activeTab === 'signup')}>
      Create Account
    </button>
  </div>
);
